import { motion } from "framer-motion";
import { ProductImage as ProductImageType } from '@wtf/shared'
import { ProductImage } from '@/components/products/ProductImage'

interface AddProductToCollectionHeaderProps {
  name: string;
  id: string;
  images: ProductImageType[];
  brand: string;
}

export const AddProductToCollectionHeader = ({
  name,
  id,
  images,
  brand,
}: AddProductToCollectionHeaderProps) => {
  const image = images?.[0];

  return (
    <motion.div
      key={id}
      className="bg-black flex items-center justify-between p-2 rounded-2xl cursor-pointer border border-[#f0f0f0] transition-colors"
    >
      <div
        className={`w-15 h-15 rounded-[0.625rem] overflow-hidden shrink-0 relative`}
      >
        {image ? (
          <ProductImage
            image={image}
            alt={name}
            className="w-full h-full backdrop-blur-2xl bg-black z-40 object-cover"
            sizes="60px"
          />
        ) : (
          <div className="w-full h-full bg-gray-200 flex items-center justify-center">
            <span className="text-gray-400 text-xs">No image</span>
          </div>
        )}
      </div>
      <div className="ml-3 flex-1">
        <h3 className="font-semibold text-sm text-white">
          {name.length > 20
            ? name.slice(0, 20) + "..."
            : name}
        </h3>
        {brand && (
          <p className="text-13 text-[#858585] font-normal">
            {brand}
          </p>
        )}
      </div>
    </motion.div>
  );
};
